import { ShoppingListPdfTemplate } from "@/components/Header/ServiceApiComponents/ShoppingList/ShoppingListPdfTemplate/ShoppingListPdfTemplate";
import {
  PdfTemplateElements,
  RecipePdfTemplate,
} from "@/components/RecipeComponents/RecipePdfTemplate/RecipePdfTemplate";
import { PrintListItem } from "@/components/RecipeComponents/RecipeSingleView/PDFDownloadButton/PDFDownloadButton";

export const setPdfTemplate = (
  pdfType: "shopping-list" | "recipe",
  printData: PrintListItem[],
  elements: PdfTemplateElements,
) => {
  switch (pdfType) {
    case "recipe":
      return <RecipePdfTemplate recipes={printData} elements={elements} />;
    case "shopping-list":
      return (
        <ShoppingListPdfTemplate recipes={printData} elements={elements} />
      );
    default:
      return null;
  }
};
